module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": _vm.headerImg
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9a54226"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBanner/index.vue
// module id = 55
// module chunks = 7 8 10 13 16 17 20 21 25